<template>
  <svg
    width="128"
    height="128"
    viewBox="0 0 128 128"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M102.548 39.0662C102.548 19.7014 85.4177 4 64.2742 4C43.1308 4 26 19.7014 26 39.0662C26 47.1022 28.9539 54.5029 33.9195 60.4214C33.9407 60.4637 33.9513 60.5167 33.9725 60.5378C36.5453 64.0318 39.7321 67.1975 41.8708 73.7724C41.9979 74.1535 42.0826 74.5452 42.1461 74.937C43.5966 83.1424 45.9259 88.4362 56.0053 88.2986C56.0265 88.3092 56.0371 88.3197 56.0582 88.3409H72.469C72.469 88.3409 72.5008 88.3197 72.522 88.2986C82.7073 88.5315 84.9307 83.1318 86.3812 74.937C86.4447 74.5452 86.54 74.1535 86.6564 73.7724C88.7951 67.1975 91.982 64.0318 94.5548 60.5378C94.576 60.5167 94.5866 60.4637 94.6077 60.4214C99.5733 54.5029 102.538 47.1022 102.538 39.0662H102.548Z"
      fill="#CB80DE"
    />
    <path
      d="M78.3875 83.5974H50.1609C46.6141 83.5974 43.7236 86.4878 43.7236 90.0347V108.129C43.7236 112.872 47.5775 116.726 52.3208 116.726H52.7231C54.7983 121.025 59.1815 124 64.2742 124C69.3668 124 73.7501 121.025 75.8253 116.726H76.2276C80.9708 116.726 84.8247 112.872 84.8247 108.129V90.0347C84.8247 86.4878 81.9343 83.5974 78.3875 83.5974Z"
    />
  </svg>
</template>

<script>
  export default {
    name: 'SavingTips'
  }
</script>
